import cn from "classnames";
import Tooltip from "rc-tooltip";
import React, { useState } from "react";

export default function ToggleFilter({
    name,
    label,
    value,
    setFilter,
    getItem,
    forceUpdateReport,
    testId,
    onBeforeChange,
    tooltip,
    tooltipPlacement = "top",
}) {
    const [blocked, setBlocked] = useState(false);
    const toggle = () => {
        if (blocked) {
            return;
        }
        if (onBeforeChange) {
            onBeforeChange(value);
        }
        setBlocked(true);
        setFilter({ name, value: !value });
        setTimeout(() => {
            getItem().then(() => {
                setBlocked(false);
                forceUpdateReport();
            });
        }, 0);
    };

    const element = (
        <div
            data-test-id={testId}
            className="mb-md-0 report__filters--mr col-form-label-sm cursor-pointer d-inline-flex align-items-center"
            onClick={toggle}
        >
            <i className={cn("checkbox d-inline-block mr-1", { "checkbox--checked": value })} />
            <span className="text-nowrap">{label}</span>
        </div>
    );

    if (tooltip) {
        return (
            <Tooltip overlay={tooltip} placement={tooltipPlacement}>
                {element}
            </Tooltip>
        );
    }

    return element;
}
